const localesWithImperialUnits = ['en', 'en-gb', 'my'];

const KM_TO_MILES = 1 / 1.60934;
const KM_TO_METERS = 1000;
const MILES_TO_YARDS = 1760;

export const formatDistance = (distance: number, locale: string) => {
  const shouldUseImperialUnits = localesWithImperialUnits.includes(locale);
  let distanceInUnit = shouldUseImperialUnits
    ? distance * KM_TO_MILES
    : distance;
  let unit = shouldUseImperialUnits ? 'mile' : 'kilometer';
  if (distanceInUnit < 0.1) {
    distanceInUnit = shouldUseImperialUnits
      ? distance * MILES_TO_YARDS
      : distance * KM_TO_METERS;
    unit = shouldUseImperialUnits ? 'yard' : 'meter';
  }

  const formatter = Intl.NumberFormat(locale, {
    style: 'unit',
    unit,
    unitDisplay: 'short',
    maximumFractionDigits: 1
  });

  return formatter.format(distanceInUnit);
};
